// Navigation Configuration
// Centralized source of truth for all navigation items

import {
  FiHome,
  FiGift,
  FiStar,
  FiShare2,
  FiUser,
  FiMessageSquare,
  FiSettings,
  FiUsers,
  FiBarChart2,
  FiImage,
  FiCoffee,
  FiRadio,
  FiDollarSign
} from 'react-icons/fi';

// Navigation groups with their items
export const navigationGroups = [
  {
    id: 'public',
    label: 'Public',
    items: [
      {
        path: '/',
        label: 'Home',
        icon: FiHome,
        minLevel: 0,
        requiresAuth: false
      }
    ]
  },
  {
    id: 'admin',
    label: 'Admin',
    dropdown: true,
    items: [
      {
        path: '/live',
        label: 'Live Orders',
        icon: FiRadio,
        minLevel: 1,
        requiresAuth: true
      },
      {
        path: '/menu-prices',
        label: 'Menu Prices',
        icon: FiDollarSign,
        minLevel: 1,
        requiresAuth: true
      },
      {
        path: '/txtr',
        label: 'Txtr',
        icon: FiMessageSquare,
        minLevel: 1,
        requiresAuth: true
      },
      {
        path: '/analytics',
        label: 'Analytics',
        icon: FiBarChart2,
        minLevel: 1,
        requiresAuth: true
      },
      {
        path: '/admin',
        label: 'Admin Panel',
        icon: FiSettings,
        minLevel: 2,
        requiresAuth: true
      },
      {
        path: '/users',
        label: 'User Management',
        icon: FiUsers,
        minLevel: 2,
        requiresAuth: true
      },
      {
        path: '/toast',
        label: 'Toast POS',
        icon: FiCoffee,
        minLevel: 2,
        requiresAuth: true
      },
      {
        path: '/admin-config',
        label: 'Config',
        icon: FiSettings,
        minLevel: 2,
        requiresAuth: true
      },
      {
        path: '/image-generator',
        label: 'Image Generator',
        icon: FiImage,
        minLevel: 2,
        requiresAuth: true
      }
    ]
  },
  {
    // Features not in use yet. Parked here, visible to level 2 only, until
    // they are finished and moved back to the Customer group.
    id: 'queue',
    label: 'Queue',
    dropdown: true,
    items: [
      {
        path: '/my-points',
        label: 'My Points',
        icon: FiGift,
        minLevel: 2,
        requiresAuth: true
      },
      {
        path: '/review',
        label: 'Review',
        icon: FiStar,
        minLevel: 2,
        requiresAuth: true
      },
      {
        path: '/share',
        label: 'Share & Earn',
        icon: FiShare2,
        minLevel: 2,
        requiresAuth: true
      },
      {
        path: '/profile',
        label: 'Profile',
        icon: FiUser,
        minLevel: 2,
        requiresAuth: true
      }
    ]
  }
];

// Flatten all items for easy lookup
export const allNavItems = navigationGroups.flatMap(group => group.items);

// Get visible items based on auth state and admin level
export const getVisibleItems = (isAuthenticated, adminLevel) => {
  return allNavItems.filter(item => {
    if (item.requiresAuth && !isAuthenticated) return false;
    if (adminLevel < item.minLevel) return false;
    return true;
  });
};

// Get visible groups with their items
export const getVisibleGroups = (isAuthenticated, adminLevel) => {
  return navigationGroups
    .map(group => ({
      ...group,
      items: group.items.filter(item => {
        if (item.requiresAuth && !isAuthenticated) return false;
        if (adminLevel < item.minLevel) return false;
        return true;
      })
    }))
    .filter(group => group.items.length > 0);
};
